module.exports = __webpack_public_path__ + "img/buro.f46be076.webp";